module.exports = __webpack_public_path__ + "img/icon3.bc4c39d6.svg";